import { render, staticRenderFns } from "./NewNavbar.vue?vue&type=template&id=2175803e&scoped=true&"
import script from "./NewNavbar.vue?vue&type=script&lang=js&"
export * from "./NewNavbar.vue?vue&type=script&lang=js&"
import style0 from "./NewNavbar.vue?vue&type=style&index=0&id=2175803e&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2175803e",
  null
  
)

export default component.exports